import { useEffect } from "react";

export function useArrowKeys({
  onArrowUp,
  onArrowDown,
}: {
  onArrowUp?: () => void;
  onArrowDown?: () => void;
}) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "ArrowUp") {
        event.preventDefault(); // Prevent page scroll
        onArrowUp?.();
      } else if (event.key === "ArrowDown") {
        event.preventDefault();
        onArrowDown?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onArrowUp, onArrowDown]);
}
